
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.25 6.959a.75.75 0 01.75-.75h9a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h7a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zm.75 5.25a.75.75 0 000 1.5h5a.75.75 0 000-1.5H4zm14-12a.75.75 0 01.75.75v10.189l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.747.747 0 01-1.06 0l-3-3a.75.75 0 111.06-1.06l1.72 1.72V6.958a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    